import { useEffect, useState } from 'react';

// Both live screens want the same two things from a stream: the latest snapshot
// and whether the stream is currently up. Pass a falsy url to stay disconnected.
//
// Owning the EventSource here is also what keeps it from leaking. Opening one
// inside a promise callback does not work: cleanup runs before the callback and
// captures nothing to close, which under StrictMode's double-invoke leaks a
// permanently reconnecting stream on every mount.
export const useLiveState = (url) => {
    const [state, setState] = useState(null);
    const [live, setLive] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        if (!url) return undefined;

        setFailed(false);
        const source = new EventSource(url);
        source.onmessage = (event) => {
            setState(JSON.parse(event.data));
            setLive(true);
            setFailed(false);
        };
        source.onerror = () => {
            setLive(false);
            // EventSource reconnects on its own for a transient drop, leaving
            // readyState at CONNECTING. It only settles into CLOSED when the
            // server has refused the connection for good (e.g. a 404 for a
            // session that no longer exists) — that's the one case nothing
            // will ever come from this stream again.
            if (source.readyState === EventSource.CLOSED) setFailed(true);
        };

        return () => source.close();
    }, [url]);

    return { state, live, failed };
};
